export { default } from './Contact'
export { ContactDialog } from './Contact.Dialog'
export * as S from './Contact.styles'
